import type { ReactNode } from 'react'

import type { ChatItem, ChatMessage, ChatNote } from './chat-message.interface'

export const isOwnItem = (item: ChatMessage | ChatNote, currentUserId: string): boolean => {
  if (item.type === 'note') return item.participant.id === currentUserId
  if (item.sender === 'user' && item.participant) return item.participant.id === currentUserId
  return false
}

export type ItemContentRenderer = (
  item: ChatItem,
  params: {
    currentUserId: string
    pinnedItemIdList: string[]
    onToolCallClick?: (id: string) => void
    onMessageClick?: (id: string) => void
    onContentBriefClick?: (id: string) => void
    onUserInteractionClick?: (id: string) => void
    onPinItem?: (id: string) => void
  }
) => ReactNode
